import { FullPageModalTemplate } from "./FullPageModalTemplate";

export { FullPageModalTemplate }